import { useAuthStep } from "@/hooks/useAuthStep";
import { useState } from "react";
import { DISCORD_OAUTH_URL } from "@/lib/config";

const DiscordIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
    </svg>
);

const Questionairre3 = () => {
    const { setAuthStep } = useAuthStep();
    const [hasClickedDiscord, setHasClickedDiscord] = useState(false);

    const handleDiscordClick = () => {
        setHasClickedDiscord(true);
        window.open("https://discord.gg/RVtnj4cf2T", "_blank");
    };

    return (
        <div className="px-[30px] mb-[30px] flex flex-col h-full text-gray-500">
            <div>
                <h1 className="text-2xl font-semibold text-black mb-[5px]">Join the BetterCampus community</h1>
                <p className="text-gray-500 text-sm">See how other students customize Canvas, share study tips, and help shape what we're building.</p>
            </div>
            <ul className="mt-[20px] space-y-[8px] text-sm text-gray-600">
                <li className="flex items-center gap-[8px]"><span>🎉</span> Free to join</li>
                <li className="flex items-center gap-[8px]"><span>💬</span> Talk directly to the creators</li>
                <li className="flex items-center gap-[8px]"><span>🚀</span> Get early access to new features</li>
            </ul>
            <div className="flex-1" />
            <div className="flex flex-col gap-[10px]">
                <button
                    onClick={handleDiscordClick}
                    className="flex items-center justify-center gap-[8px] py-[12px] rounded-full w-full font-medium text-white bg-[#5865F2] hover:bg-[#4752c4] transition-colors"
                >
                    <DiscordIcon />
                    Join the Discord
                </button>
                <button
                    style={{ background: "linear-gradient(90deg, #ffa952,#ff686c)" }}
                    className="flex items-center justify-center gap-[8px] py-[12px] rounded-full w-full font-medium text-white"
                    onClick={() => setAuthStep("thankYou")}
                >
                    {hasClickedDiscord ? "Finish" : "Skip"}
                </button>
            </div>
        </div>
    );
};

export default Questionairre3;
